import React from 'react';
import PropTypes from 'prop-types';
import { View, TouchableWithoutFeedback } from 'react-native';
import analytics from '../../../modules/analytics';

/**
 * Wraps `TouchableWithoutFeedback` with a `sidebar_click` tracking call
 */
const TrackableOnPress = ({
  trackingKey,
  className,
  children,
  onPress,
  style,
}) => {
  /**
   * Handles the press, expects to receive SyntheticEvent
   */
  const handlePress = e => {
    analytics.track('sidebar_click', { item: trackingKey });

    if (typeof onPress === 'function') {
      onPress(e);
    }
  };

  return (
    <TouchableWithoutFeedback onPress={handlePress}>
      <View className={className} style={style}>
        {children}
      </View>
    </TouchableWithoutFeedback>
  );
};

TrackableOnPress.propTypes = {
  /** Called when pressed, receives the synthetic event */
  onPress: PropTypes.func,
  /** Children to render */
  children: PropTypes.node,
  /** Specifies the class name */
  className: PropTypes.string,
  /** ID to use in tracking calls */
  trackingKey: PropTypes.string,
  /** Specifies the style */
  style: PropTypes.any,
};

TrackableOnPress.defaultProps = {
  onPress: null,
  children: null,
  className: '',
  trackingKey: '',
  style: undefined,
};

export default TrackableOnPress;
